<div [ngClass]="class">
  @for (card of cards; track card; let i = $index) {
    <pr-card
      [card]="card"
      prLoader
      [loading]="loading"
      [ngClass]="{ fill: card.fill }"
    ></pr-card>
  }
</div>
